import React, { useState } from "react";
import { Button, Input, message } from "antd";
const { TextArea } = Input;
import { Axios, readAuthToken } from "../../utils/axiosMiddleware";
import { useSelector } from "react-redux";
import lodash from "lodash";
import Loader from "../GeneralComponents";
import { injectIntl } from "react-intl";
function ThirdPage({ current, setCurrent, ...props }) {
  const data = useSelector((state) => state?.common?.fullUser);
  const [introText, setIntroText] = useState(
    data?.current_type === "contractor"
      ? data?.contractor?.intro_text
      : data?.current_type === "tradesman"
      ? data?.tradesman?.intro_text
      : data?.homeowner?.intro_text || ""
  );
  const accessToken = readAuthToken();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    const validationErrors = {};
    if (!introText?.trim()) {
      validationErrors.introText = `${props.intl.formatMessage({
        id: "intro_is_required",
      })}`;
    }

    if (Object.keys(validationErrors).length > 0) {
      message.error(`${props.intl.formatMessage({ id: "intro_is_required" })}`);
      return;
    }
    // Shared instance for the auth header and the 401 session redirect. The old
    // hand-rolled call read `error.response.data.message` unguarded, so a network
    // error (no `response`) threw a TypeError inside its own catch and the user got
    // a generic message for every failure — including ones the server explained.
    try {
      setLoading(true);
      await Axios.patch(`user/${accessToken?.user_id}`, {
        intro_text: introText,
        user_type: accessToken?.user_type,
      });
      setCurrent((prevCurrent) => prevCurrent + 1);
    } catch (error) {
      message.error(
        `${props.intl.formatMessage({ id: "something_went_wrong" })}`
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-50">
      {loading && (
        <div className="search-loader">
          <Loader />
        </div>
      )}

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <TextArea
          rows={15}
          placeholder={props.intl.formatMessage({ id: "tell_us" })}
          className="border rounded shadow p-3 h-50"
          onChange={(e) => setIntroText(e.target.value)}
          autoSize={true}
          defaultValue={introText}
        ></TextArea>

        <div className="d-flex justify-content-between mt-5">
          <div>
            {current > 0 && (
              <Button
                style={{
                  width: "120px",
                  height: "56px",
                  color: "#F77E0B",
                  border: "2px solid #F77E0B",
                }}
                onClick={() => setCurrent((prevCurrent) => prevCurrent - 1)}
              >
                {props.intl.formatMessage({ id: "previous" })}
              </Button>
            )}
          </div>
          <div>
            {current < 5 && (
              <Button
                style={{
                  width: "120px",
                  backgroundColor: "#F77E0B",
                  height: "56px",
                  color: "white",
                }}
                type="submit"
                htmlType="submit"
              >
                {props.intl.formatMessage({ id: "next" })}
              </Button>
            )}
          </div>
        </div>
      </form>
    </div>
  );
}
export default injectIntl(ThirdPage);
